import React from 'react';
import { getTranslation } from '../../../utils/translation';
import styles from './LiveBadge.module.css';

const LiveBadge = ({ isLive }) => {
    return isLive ? <span className={styles.badge}>{getTranslation('common.live')}</span> : null;
};

export default LiveBadge;
